import { SelcetOption } from "../../../../model/common/apiResponse";

export interface CreateOrder {
    order_number?: string;
    customer: any;
    customer_bill_to: any;
    customer_ship_to: any;
    ship_to_name: any;
    address_line_1: any;
    address_line_2: any;
    city: any;
    state_province: any;
    postal_code: any;
    country: any;
    order_date: any;
    ship_by_date: any;
    contact_name: any;
    contact_phone: any;
    carrier: any;
    serviceLevel: any;
    notes_1: any;
    special_instructions: any;
    customer_po_number:string | null;
    customer_order_number:string| null;
    // country_code?: string;
    lines: any;
}

export const deafultOrderValue: CreateOrder = {
    // country_code:'',
    customer: '',
    customer_bill_to: '',
    customer_ship_to: '',
    ship_to_name: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    state_province: '',
    postal_code: '',
    country: '',
    order_date: new Date().toISOString().split('T')[0],
    ship_by_date: '',
    contact_name: '',
    contact_phone: '',
    carrier: '',
    serviceLevel: '',
    notes_1: '',
    special_instructions: '',
    customer_po_number:'',
    customer_order_number:'',
    lines: []
}

export interface OrderLookup {
    customer: SelcetOption[];
    carrier: SelcetOption[];
    country: SelcetOption[];
}

export interface ShipToLookup {
    shipTo: SelcetOption[];
}

export interface ServiceLevelLookup {
    serviceLevel: SelcetOption[];
}
export interface Order {
    id?: number | null;
    created_by?: number | null;
    created_at?: string | null;
    updated_by?: number | null;
    updated_at?: string | null;
    locked_by?: number | null;
    locked_by_user?: [] | null;
    locked_at?: string | null;
    lock_expires?: string | null;
    client?: Client | null;
    customer?: Customer | null;
    customer_bill_to?: CustomerBillTo | null;
    customer_ship_to?: CustomerShipTo | null;
    address_line_1?: string | null;
    address_line_2?: string | null;
    city?: string | null;
    state_province?: string | null;
    postal_code?: string | null;
    country?: Country | null;
    // country_code?: string | null;
    contact_name?: string | null;
    contact_phone?: string | null;
    contact_email?: string | null;
    status?: string | null;
    statusLookup?: StatusLookup | null;
    source?: string | null,
    order_number?: string | null;
    customer_po_number?: string | null;
    customer_order_number?: string | null;
    order_date?: string | null;
    ship_by_date?: string | null;
    special_instructions?: string | null;
    notes_1?: string | null;
    external_identifier?: string | null;
    lines?: Line[] | null;
}

export interface Client {
    id?: number | null;
    code?: string | null;
    name?: string | null;
    is_active?: boolean | null;

}

export interface Customer {
    id?: number | null;
    code?: string | null;
    name?: string | null;
    is_active?: boolean | null;
}

export interface CustomerBillTo {
    id?: number | null;
    code?: string | null;
    name?: string | null;
    address_line_1?: string | null;
    address_line_2?: string | null;
    city?: string | null;
    state_province?: string | null;
    postal_code?: string | null;
    country?: string | null
    contact_name?: string | null;
    contact_phone?: string | null;
    contact_email?: string | null;
    is_active?: boolean | null;
}

export interface CustomerShipTo {
    id?: number | string;
    customer_id?: number | null;
    code?: string | null;
    name?: string | null;
    address_line_1?: string | null;
    address_line_2?: string | null;
    city?: string | null;
    state_province?: string | null;
    postal_code?: string | null;
    country?: Country | null
    contact_name?: string | null;
    contact_phone?: string | null;
    contact_email?: string | null;
    is_residential?: boolean
}

export interface Country {
    code?: string | null;
    name?: string | null;
}

export interface StatusLookup {
    id?: number | null;
    type?: string | null,
    code?: string | null;
    description?: string | null;
}

export interface Line {
    id?: number | null;
    created_by?: number | null;
    created_at?: string | null;
    updated_by?: number | null;
    updated_at?: string | null;
    purchase_order_line?: string | null;
    item?: Item | null;
    line_number?: number | null;
    qty_expected?: string | null;
    qty_received?: string | null;
    uom_code?: string | null;
    unit_cost?: string | null;
    supplier_line_number?: string | null;
    supplier_item_code?: string | null;
    external_identifier?: string | null;
  }


  export interface Item {
    id?: number | null;
    code?: string | null;
    name?: string | null;
    description?: string | null;
    is_tag_tracking?: boolean | null;
    is_lot_tracking?: boolean | null;
    is_expiry_tracking?: boolean | null;
    serial_tracking?: number | null;
    serial_tracking_lookup?: string | null;
    fifo_method?: string | null;
    fifo_date_method?: string | null;
    base_uom?: string | null;
    default_purchase_uom?: string | null;
    default_sale_uom?: string | null;
    is_active?: boolean | null;
    attachments?: any[] | null;
  }

  export interface RequestOrderData {
    customer: {code: string};
  }
export interface OrderOverview {
    id: number;
    order_number?: string;
    ship_to_name: string;
    ship_by_date: string;
    no_of_lines: number;
    no_of_shipments: null | string;
    no_of_warehouses: number;
    total_qty_ordered: number;
    total_qty_shipped: number;
    status: string;
}